(ns global.endor.checkout.api.transit
  (:require [cljs-bean.transit]
            [cognitect.transit :as transit]))

(def transit-reader
  (transit/reader :json
                  {:handlers {"Instant" (transit/read-handler #(js/Date. %))}}))

(def transit-writer
  (transit/writer :json
                  {:handlers (merge (cljs-bean.transit/writer-handlers)
                                    {js/Date (transit/write-handler (constantly "Instant")
                                                                    #(.getTime %))})}))

(defn read-transit [string]
  (transit/read transit-reader string))

(defn write-transit [clj-data]
  (transit/write transit-writer clj-data))
